import { ListLayoutKey, ListLayoutTypes } from "@/interfaces/listLayout";

export function getSelectedTypeKey(type: string): ListLayoutKey {
    const layout = Object.values(ListLayoutTypes).find(
        layout => layout.key === type
    );

    return layout?.key ?? ListLayoutTypes.socialList.key;
}